import { useNavigate } from "@tanstack/react-router";
import { FormEvent, useState } from "react";

import { ApiError, api } from "../lib/api";
import { btnPrimary } from "../components/ui";

// Login do portal — mesma tela do Valquiria (routes/login.tsx), só com a placa
// da Carmillion sem o selo "Valquiria".

const input: React.CSSProperties = { width: "100%", padding: "9px 12px", background: "var(--surface-input)", border: "1px solid var(--line)", borderRadius: 8, color: "var(--ink)", fontSize: 14, outline: "none" };

export function Login() {
  const nav = useNavigate();
  const [login, setLogin] = useState("");
  const [pwd, setPwd] = useState("");
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setErr(null);
    setBusy(true);
    try {
      await api.post("/login", { login, password: pwd });
      nav({ to: "/" });
    } catch (e) {
      setErr(e instanceof ApiError ? (e.detail ?? "Login ou senha inválidos") : "Sem conexão com o servidor");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "var(--surface-app)", padding: "0 16px" }}>
      <form onSubmit={onSubmit} style={{ width: "100%", maxWidth: 360, background: "var(--surface-card)", border: "1px solid var(--line)", borderRadius: 12, padding: 28, display: "flex", flexDirection: "column", gap: 14, boxShadow: "var(--shadow-modal)" }}>
        <div style={{ display: "flex", alignItems: "center", background: "var(--logo-plate)", borderRadius: 8, padding: "12px 14px", marginBottom: 6 }}>
          <img src="/logo-carmillion.avif" alt="Carmillion" style={{ height: 26, width: "auto", objectFit: "contain" }} />
        </div>
        <input style={input} placeholder="Login" name="login" autoComplete="username" aria-label="Login" value={login} onChange={(e) => setLogin(e.target.value)}
          onFocus={(e) => (e.currentTarget.style.borderColor = "var(--brand)")} onBlur={(e) => (e.currentTarget.style.borderColor = "var(--line)")} />
        <input type="password" style={input} placeholder="Senha" name="password" autoComplete="current-password" aria-label="Senha" value={pwd} onChange={(e) => setPwd(e.target.value)}
          onFocus={(e) => (e.currentTarget.style.borderColor = "var(--brand)")} onBlur={(e) => (e.currentTarget.style.borderColor = "var(--line)")} />
        {err && <p style={{ color: "var(--danger)", fontSize: 13 }}>{err}</p>}
        <button type="submit" disabled={busy} style={{ ...btnPrimary, width: "100%", padding: 9, fontSize: 14 }}>{busy ? "Entrando…" : "Entrar"}</button>
      </form>
    </div>
  );
}
